export enum MINT_MODE {
  JOIN,
  CREATE
}
